<template>
  <MandatorySliderSelector :items="computedItems" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import MandatorySliderSelector from "./MandatorySliderSelector";
export default {
  components: {
    MandatorySliderSelector,
  },
  props: {
    largeTile: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [
        {
          slug: "some-slug",
          image: "/path/to/image.jpg",
          title: "Item Title",
          subtitle: "Description",
          color: "#FFE5AA",
          price_tag: "25 €",
        },
      ],
    },
  },
  computed: {
    computedItems() {
      return this.items.map((item) => this.mapItem(this._.cloneDeep(item)));
    },
  },

  methods: {
    mapItem(item) {
      const price = this._.get(item, [
        "surcharge",
        this.largeTile ? "tiled_120x60" : "tiled_60x60",
      ]);
      if (price) item.price_tag = "+" + price + " €/m²";
      return item;
    },
  },
};
</script>
